module.exports = __webpack_public_path__ + "static/media/dashboard-notes.6b8ca5e6.svg";